<div
  class="media-list"
  cdkDropList (cdkDropListDropped)="drop($event)"
>
  @if (files.length > 1) {
    <div class="media-list__process-section">
      <mat-expansion-panel
        class="no-active-blue-color media-list__select-button"
        #commonReg
        (opened)="commonRegVisible = true"
        (closed)="commonRegVisible = false"
        [disabled]="parentObject.$$annotateImage || disableCommonReg()"
      >
        <mat-expansion-panel-header
          [matTooltip]="'TRANS__MEDIA_LIST__DISABLE_COMMON_REGISTRATION_BUTTON_TOOLTIP' | translate"
          matTooltipPosition="above"
          [matTooltipDisabled]="!disableCommonReg()"
        >
          <mat-checkbox
            class="media-list__select-button-checkbox white-bg-in-checkbox"
            (ngModelChange)="checkAll($event, commonReg)"
            [(ngModel)]="allChecked"
            [checked]="allChecked"
            [indeterminate]="checkIfFileIsSelected()"
          >
            <span>
              {{ 'TRANS__MEDIA_LIST__SELECT_ALL' | translate }}
            </span>
          </mat-checkbox>

          <span [ngClass]="{'bold': commonReg.expanded}">
            {{ 'TRANS__MEDIA_LIST__SET_SIMILAR_INFORMATION' | translate }}
          </span>
        </mat-expansion-panel-header>

        @if (commonContainer) {
          <app-edit-prime-fields
            [sectionsContainer]="commonContainer"
          ></app-edit-prime-fields>
        }
      </mat-expansion-panel>
    </div>
  }

  @for (file of getPageFiles(); track $index) {
    <ng-container>
      @if (!crud.getDestroy(file)) {
        <div
          class="media-list__files"
          [ngClass]="{'active': file['checked'], 'handleSelection':commonRegVisible && file['checked']}"
          cdkDragBoundary=".media-list" cdkDrag
          [cdkDragPreviewClass]="isDialog ? 'dialog' : ''"
        >
          <!-- Take a look at this at a later time to se what we can do with the Warning -->
          <div class="custom-placeholder" *cdkDragPlaceholder></div>

          <div class="media-list__files-container">
            <div class="media-list__files-img-container">
              <div
                class="checkbox-underlay"
                [ngClass]="{'disabled': parentObject.$$annotateImage}"
              >
                <mat-checkbox
                  class="white-bg-in-checkbox"
                  [(ngModel)]="file['checked']"
                  (ngModelChange)="fileChecked(file)"
                  [checked]="file['checked']"
                ></mat-checkbox>
              </div>

              <app-thumbnail
                class="media-list__img"
                [item]="file"
                [imageIdField]="getObjectIdField(file)"
                [viewMode]="'thumbnail'"
                [stylingClass]="'media-list-image'"
              ></app-thumbnail>

              @if (canAnnotate(file)) {
                <button
                  (click)="annotateImage(file)"
                  class="media-list__files-img-container__annotate-button"
                  [ngClass]="{'active': parentObject.$$annotateImage && file.$$annotateImage,
                              'disabled': parentObject.$$annotateImage && !file.$$annotateImage}"
                >
                  <i class="icon-annotate"></i>

                  <span>
                    {{ 'TRANS__IMAGE_SELECTOR__ANNOTATE_IMAGE' | translate }}
                  </span>
                </button>
              }
            </div>

            <div
              class="media-list__files-content"
              [ngClass]="{'disabled': parentObject.$$annotateImage}"
            >
              <div class="media-list__files-content-header">
                <span class="media-list__file-name">
                  {{ file.artifact_name }}
                </span>

                <div class="media-list__files-content-header-buttons">
                  <button
                    mat-icon-button
                    [matMenuTriggerFor]="fileMenu"
                    [attr.aria-label]="('TRANS__IMAGE_SELECTOR__FILE_ACTIONS' | translate) + ': ' + file.artifact_name"
                  >
                    <mat-icon>more_vert</mat-icon>
                  </button>
                  <mat-menu #fileMenu="matMenu">
                    <button
                      mat-menu-item
                      (click)="deleteFile($index)"
                    >
                      <span>
                        {{ 'TRANS__DELETE_ITEM__DELETE' | translate }}
                      </span>
                    </button>
                  </mat-menu>

                  @if (files.length > 1) {
                    <button
                      class="media-list__files-content-move-button"
                      mat-button
                      cdkDragHandle
                    >
                      <i class="icon-row-sort"></i>
                    </button>
                  }
                </div>
              </div>

              @if (getFileContainer(file)) {
                <app-edit-prime-fields
                  [sectionsContainer]="fileContainers[file.$$id]"
                ></app-edit-prime-fields>
              }
            </div>
          </div>
        </div>
      }
    </ng-container>
  }

  @if (getPages().length > 1) {
    <div>
      <span>
        {{ 'TRANS__MEDIA_LIST__PAGE_NUMBER' | translate }}
      </span>

      @for (page of getPages(); track $index) {
        <ng-container>
          <button
            mat-button
            (click)="setPage(page)"
          >
            {{page + 1}}
          </button>
        </ng-container>
      }
    </div>
  }
</div>
